import { useEffect, useState } from 'react';
import { toast } from 'sonner';
import { adminListPostal, adminVerifyPostal } from '@/lib/api';
import { formatDateShort } from '@/lib/format';

const AdminPostal = () => {
  const [items, setItems] = useState([]);
  const load = () => adminListPostal().then((d) => setItems(d.items || []));
  useEffect(() => { load(); }, []);
  const verify = async (id) => { try { await adminVerifyPostal(id); toast.success('Verified'); load(); } catch { toast.error('Failed'); } };
  return (
    <div data-testid="admin-postal-page">
      <h1 className="font-display text-4xl">Postal entries</h1>
      <div className="mt-6 overflow-x-auto border border-pd rounded-2xl">
        <table className="w-full text-sm">
          <thead>
            <tr className="text-left font-mono text-[10px] text-muted-sage uppercase">
              <th className="p-3">Ticket</th>
              <th className="p-3">Name</th>
              <th className="p-3">Email</th>
              <th className="p-3">Postcode</th>
              <th className="p-3">Status</th>
              <th className="p-3">Created</th>
              <th className="p-3"></th>
            </tr>
          </thead>
          <tbody>
            {items.map((p) => (
              <tr key={p.id} className="border-t border-pd">
                <td className="p-3 font-mono text-xs">{p.ticket_number}</td>
                <td className="p-3">{p.full_name}</td>
                <td className="p-3">{p.email}</td>
                <td className="p-3">{p.address?.postcode}</td>
                <td className="p-3 font-mono text-xs">{p.status}</td>
                <td className="p-3 text-xs text-muted-sage">{formatDateShort(p.created_at)}</td>
                <td className="p-3 text-right">
                  {p.status !== 'verified' && (
                    <button onClick={() => verify(p.id)} className="border border-[color:var(--pd-accent-yellow)] text-[color:var(--pd-accent-yellow)] rounded-lg px-2 py-1 text-xs">Verify</button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {!items.length && <div className="mt-4 font-mono text-sm text-muted-sage">No postal entries yet.</div>}
    </div>
  );
};
export default AdminPostal;
